import { render, staticRenderFns } from "./createCert.vue?vue&type=template&id=bf13eef4&scoped=true&"
import script from "./createCert.vue?vue&type=script&lang=js&"
export * from "./createCert.vue?vue&type=script&lang=js&"
import style0 from "./createCert.vue?vue&type=style&index=0&id=bf13eef4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf13eef4",
  null
  
)

component.options.__file = "createCert.vue"
export default component.exports